import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import SEO from './SEO';
import { getPageSeo } from '../seo/getPageSeo';
import { buildOrganizationJsonLd } from '../seo/structuredData';

export default function DocumentHead() {
  const { pathname } = useLocation();
  const seo = getPageSeo(pathname);
  const jsonLd = pathname === '/' ? buildOrganizationJsonLd() : null;

  return (
    <>
      <SEO
        title={seo.title}
        description={seo.description}
        canonical={seo.canonical}
        robots={seo.robots}
        ogTitle={seo.ogTitle}
        ogDescription={seo.ogDescription}
        ogUrl={seo.ogUrl}
      />
      {jsonLd ? (
        <Helmet>
          <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
        </Helmet>
      ) : null}
    </>
  );
}
